import React from 'react';
import { motion } from 'framer-motion';
import './AboutUs.css';

const AboutUs: React.FC = () => {




  return (
    <div className="about-us-page">
      <div className="about-us-container">


        {/* Main Content */}
        <div className="about-us-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="journey-leadership-section"
          >
            <div className="story-header">
              <div className="story-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/agriculture.jpg)` }}
              >
                <div className="story-header-overlay">
                  <h2 className="section-main-title">Our Story</h2>
                </div>
              </div>
            </div>
            <div className="journey-leadership-container">
              {/* Our Journey Section */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="story-section"
              >
                <div className="story-content">
                  <div className="story-text">
                    <p className="story-intro">
                      Established in 1993, Ansuvara Group stands today as one of Nepal's most dynamic, influential, and respected business conglomerates, built on 30+ years of excellence across automobiles, real estate, housing, hospitality, financial services, and several emerging sectors.
                    </p>

                    <p>
                      The Group's journey began with a modest motorcycle rental venture founded by Mr. Bindu Kumar Thapa, whose determination, foresight, and entrepreneurial resilience transformed a small-scale operation into a nationally recognized business house. From its earliest days, Mr. Thapa demonstrated a remarkable ability to identify opportunities ahead of their time, establishing Nepal's first official recondition showroom, introducing Pokhara's first two-wheeler dealership with Daelim Bikes, and gradually expanding into multiple automobile showrooms, positioning Ansuvara Group as a key player in Nepal's automobile industry.
                    </p>

                    <p>
                      His leadership and influence helped shape the sector nationwide, reflected in his tenure as Vice President of the Nepal Automobile Dealers Association (NADA) from 2008–2010 and later as President of the Pokhara Chamber of Commerce and Industry from 2014–2016, where he actively contributed to strengthening the region's economic and commercial ecosystem.
                    </p>

                    <p>
                      Beyond automobiles, Mr. Thapa played a defining role in Nepal's financial development as one of the founding visionaries behind Fewa Finance Bank, one of the earliest finance institutions established in Pokhara. During these transformative years, Mr. Thapa served as Chairman of Fewa Bikas Bank starting on 3 May 2016, guiding the institution through an important era of consolidation, regulatory evolution, and sectoral growth.
                    </p>

                    <p>
                      As the Group continued to evolve, it established a significant presence in real estate and housing, now recognized as one of its strongest and most impactful business pillars. Ansuvara Group has developed 2,000+ ropanis of land, completed 76+ residential and commercial projects, and continues to expand its portfolio with innovative developments designed to support modern urban living. The Group also holds a major stake in Pokhara Trade Mall, the largest mall in Nepal, marking its influence in urban infrastructure and large-scale commercial ventures.
                    </p>

                    <p>
                      With ventures spanning property development, construction, retail infrastructure, hospitality, and financial services, Ansuvara Group has generated 500+ jobs, contributing actively to Nepal's economic progress and creating opportunities across diverse communities. Its sustained growth is rooted in a mission to deliver quality, foster entrepreneurship, and build businesses that stand the test of time.
                    </p>

                    <p>
                      Beyond business, Mr. Bindu Kumar Thapa has made significant contributions to public service after retiring from business, representing the Nepali Congress Party as a Member of the Provincial Assembly of Gandaki Province from 2017 to 2022, and holding the portfolio of Minister for Law, Communication, and Provincial Affairs between July 2021 and December 2022. Re-elected in 2022, he now serves as the Minister for Social Development, Youth, and Sports in Gandaki Province, exemplifying vision, integrity, and dedication to public welfare.
                    </p>

                    <p>
                      Building on this legacy, Mr. Saugat Thapa drives the operational leadership and strategic direction of Ansuvara Group with a modern, forward-thinking approach, emphasizing innovation, sustainability, and global business standards. Together, their leadership has established a foundation of trust, progress, and responsible entrepreneurship, making Ansuvara Group—a resilient, transformative enterprise with over three decades of achievement—a symbol of opportunity, growth, and long-term value creation in Pokhara and beyond, shaping industries, inspiring communities, and contributing to Nepal's economic future.
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* Leadership Section */}
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
                className="leadership-section"
              >

                <div className="leadership-grid">
                  {/* Founder */}
                  <a href="https://bindukumarthapa.com/" target="_blank" rel="noopener noreferrer">
                    <div className="leadership-item">
                      <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        viewport={{ once: true }}
                        className="leadership-image"
                      >
                        <div className="image-placeholder"
                          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bindu.webp)` }}
                        >
                        </div>
                      </motion.div>
                      <div className="leadership-text">
                        <h4>Mr. Bindu Kumar Thapa</h4>
                        <p>Chairman</p>
                      </div>
                    </div>
                  </a>
                  {/* Director */}
                  <a href="https://bindukumarthapa.com/" target="_blank" rel="noopener noreferrer">
                    <div className="leadership-item">
                      <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        viewport={{ once: true }}
                        className="leadership-image"
                      >
                        <div className="image-placeholder"
                          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/saugat.webp)` }}
                        >
                        </div>
                      </motion.div>
                      <div className="leadership-text">
                        <h4>Mr. Saugat Thapa</h4>
                        <p>Managing Director</p>
                      </div>
                    </div>
                  </a>
                </div>
              </motion.div>
            </div>
          </motion.div>


        </div>
      </div>
    </div>
  );
};

export default AboutUs;
